import { NgModule } from '@angular/core';
import { EventsOutsideAngularDirective } from './common/events-outside-angular.directive';
/**
 * @hidden
 */
export class EventsModule {
}
EventsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [EventsOutsideAngularDirective],
                exports: [EventsOutsideAngularDirective]
            },] },
];
/** @nocollapse */
EventsModule.ctorParameters = () => [];
